import axios from 'axios';

export function api(url, params = {}) {
    return axios({
        baseURL: process.env.VUE_APP_MAILER_API,
        params: params,
        method: 'post',
        url: url,
    });
}
